/**
 * Gemini 3.1 Flash TTS transcript audio tags.
 * Source: https://ai.google.dev/gemini-api/docs/speech-generation#transcript-tags
 *
 * Inserted inline in the script as `[tag]`. The TTS engine treats them as
 * performance cues (delivery, pacing, non-verbal sounds) and does not read them aloud.
 *
 * Order roughly reflects usefulness for podcast hosts.
 */
export const AVAILABLE_EMOTIONS = [
    // Delivery cues (most common for podcasts)
    'excited',
    'amused',
    'thoughtful',
    'skeptical',
    'surprised',
    'serious',
    'curious',
    'sarcastic',
    'whispers',
    'shouting',
    'reluctantly',
    'bored',
    'mischievously',
    'trembling',
    'panicked',
    'crying',

    // Pacing
    'short pause',
    'long pause',
    'very fast',
    'very slow',

    // Non-verbal sounds
    'laughs',
    'giggles',
    'sighs',
    'gasp',
    'cough',
    'breath',
]
